import { allImages } from "../assets/images";

export const ACCESSORY_TYPE_ALIASES = {
  mountainjeep: "car",
  jeep: "car",
  taxi: "car",
  taxi1: "car",
  supercar: "car",
  exporter: "truck",
  cargoship: "boat",
  custom: "car",
  cycle: "bike",
  motorcycle: "bike",
  scooter: "scooty",
  scootor: "scooty",
  rickshaw: "auto",
  autorickshaw: "auto",
  police: "policecar",
  policecar: "policecar",
  policebike: "policebike",
  policebus: "policebus",
  lorry: "truck",
  trailer: "truck",
  dumper: "dumpher",
  tipper: "dumpher",
  earthmover: "bulldozer",
  school_bus: "schoolbus",
  schoolbus: "schoolbus",
  delivery_van: "van",
  deliveryvan: "van",
  tracktor: "tractor",
  excavator: "jcb",
  plane: "car",
};

const DEFAULT_ICON_KEY = "car";
const DEFAULT_ICON_COLOR = "blue";

const STATUS_TO_ICON_COLOR = {
  running: "green",
  moving: "green",
  idle: "yellow",
  idling: "yellow",
  stopped: "red",
  parked: "red",
  parking: "red",
  inactive: "blue",
  offline: "blue",
  expired: "purple",
  no_data: "black",
  nodata: "black",
  unknown: "black",
};

const toCompactKey = (value) => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");

export const normalizeVehicleIconKey = (...candidates) => {
  for (const candidate of candidates) {
    const compact = toCompactKey(candidate);
    if (!compact) continue;
    const resolved = ACCESSORY_TYPE_ALIASES[compact] || compact;
    if (allImages[resolved]) return resolved;
  }
  return DEFAULT_ICON_KEY;
};

export const resolveVehicleIconColor = (status, fallback = DEFAULT_ICON_COLOR) => {
  const compact = toCompactKey(status);
  return STATUS_TO_ICON_COLOR[compact] || fallback;
};

export const resolveVehicleIconAsset = (iconSource, options = {}) => {
  const status = options?.status;
  const explicitColor = toCompactKey(options?.color);
  const key =
    typeof iconSource === "object" && iconSource !== null
      ? normalizeVehicleIconKey(
          iconSource.iconCategory,
          iconSource.vehicleType,
          iconSource.deviceIcon,
          iconSource.vehicleIcon,
          iconSource.icon
        )
      : normalizeVehicleIconKey(iconSource);

  const iconSet = allImages[key] || allImages[DEFAULT_ICON_KEY];
  const preferredColor = explicitColor || resolveVehicleIconColor(status, DEFAULT_ICON_COLOR);

  return (
    iconSet?.[preferredColor] ||
    iconSet?.[DEFAULT_ICON_COLOR] ||
    iconSet?.black ||
    allImages[DEFAULT_ICON_KEY]?.[DEFAULT_ICON_COLOR] ||
    allImages[DEFAULT_ICON_KEY]?.black ||
    ""
  );
};
